import { Fragment } from 'react';

import {
  APPAREL_GENDER_OPTIONS, APPAREL_GENDER_VALUE_MEN, APPAREL_SIZE_OPTIONS,
  APPAREL_TYPE_NAME_SHOE, MEN_SHOE_SIZE_OPTIONS, WOMEN_SHOE_SIZE_OPTIONS
} from './ApparelFormGridConstants';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import CloneIcon from '@usas/ui-web/components/icons/CloneIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from './ApparelFormGrid.module.css';

const GridRow = ({ apparel, onUpdateApparelGender, onUpdateApparelSize }) => {
  if (apparel.name.includes(APPAREL_TYPE_NAME_SHOE)) {
    const apparelGenderOption = APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId) || APPAREL_GENDER_OPTIONS[0];
    const apparelSizeOptions = apparelGenderOption.value === APPAREL_GENDER_VALUE_MEN
      ? MEN_SHOE_SIZE_OPTIONS
      : WOMEN_SHOE_SIZE_OPTIONS;

    return (
      <tr>
        <td>{apparel.name || ''}</td>
        <td style={{ width: "30%" }}>
          {apparel.hasGenderType === true
            ? (
              <Dropdown
                name={`apparelGenderId${apparel.id}`}
                value={apparel.apparelGenderId}
                isLoading={false}
                options={APPAREL_GENDER_OPTIONS.filter((x) => x.displayInDropdown === true)}
                onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelGender(apparel.id, newValue) }} />
            ) : <span style={{ padding: '2px 5px' }}>{APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId)?.name || ''}</span>
          }
        </td>
        <td style={{ width: "30%" }}>
          <Dropdown
            name={`apparelSizeId${apparel.id}`}
            value={apparel.apparelSizeId}
            isLoading={false}
            options={apparelSizeOptions}
            onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelSize(apparel.id, newValue) }} />
        </td>
        <td></td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{apparel.name || ''}</td>
      <td style={{ width: "30%" }}>
        {apparel.hasGenderType === true
          ? (
            <Dropdown
              name={`apparelGenderId${apparel.id}`}
              value={apparel.apparelGenderId}
              isLoading={false}
              options={APPAREL_GENDER_OPTIONS.filter((x) => x.displayInDropdown === true)}
              onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelGender(apparel.id, newValue) }} />
          ) : <span style={{ padding: '2px 5px' }}>{APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId)?.name || ''}</span>
        }
      </td>
      <td style={{ width: "30%" }}>
        <Dropdown
          name={`apparelSizeId${apparel.id}`}
          value={apparel.apparelSizeId}
          isLoading={false}
          options={APPAREL_SIZE_OPTIONS}
          onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelSize(apparel.id, newValue) }} />
      </td>
      <td>
        {apparel.hasValue === true &&
          <Fragment>
            <button className={global.IconButtonMargin} type="button" onClick={() => onUpdateApparelSize(-1, apparel.apparelSizeId)}>
              <CloneIcon toolTipText='Apply Size To All' />
            </button>
          </Fragment>
        }
      </td>
    </tr>
  );
}

const ApparelFormGridLarge = ({ formGridState, onUpdateApparelGender, onUpdateApparelSize }) => (
  <table className={[global.UsasTable, style.LargeFormGrid, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Apparel</th>
        <th>Type</th>
        <th>Size</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {Array.isArray(formGridState) && formGridState.length > 0
        ? formGridState.map((apparel, i) =>
          <GridRow key={i} apparel={apparel} onUpdateApparelGender={onUpdateApparelGender} onUpdateApparelSize={onUpdateApparelSize} />)
        : <tr><td colSpan="4">No Apparel</td></tr>
      }
    </tbody>
  </table>
);

export default ApparelFormGridLarge;


